import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import BetaBanner from 'components/BetaBanner';
import GeckoLocation from 'services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import GeckoFeatures from 'services/gecko-features';
import ChannelEditModal from './components/ChannelEditModal.jsx';
import {
  GeckoRow,
  GeckoModalService,
  GeckoToastService,
  GeckoCardImage,
  GeckoCol,
  GeckoBtn,
} from 'ui';
import './NewChannel.scss';

const liveChatImg = `${process.env.PUBLIC_URL}/channels/live_chat.png`;
const facebookImg = `${process.env.PUBLIC_URL}/channels/facebook.png`;
const instagramImg = `${process.env.PUBLIC_URL}/channels/instagram.png`;
const twilioImg = `${process.env.PUBLIC_URL}/channels/twilio.png`;
const twitterImg = `${process.env.PUBLIC_URL}/channels/twitter.png`;
const mailgunImg = `${process.env.PUBLIC_URL}/channels/mailgun.png`;
const whatsappImg = `${process.env.PUBLIC_URL}/channels/whatsapp.png`;

class NewChannel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      channel: this.props.channel || null,
    };
  }

  static contextTypes = {
    history: PropTypes.object,
  };

  channelTypes = [
    {
      type: 'live_chat',
      name: 'Live Chat',
      description: (
        <span>
          Add a custom{' '}
          <a
            href="http://academy.geckoengage.com/en/articles/6962551-channels#h_5ec8a6b2d3"
            target="_blank"
          >
            live chat
          </a>{' '}
          widget to your website and allow your visitors to instant message you.
        </span>
      ),
      icon: liveChatImg,
      onSave: this.onSave.bind(this),
    },
    {
      type: 'facebook',
      name: 'Facebook Messenger',
      description: (
        <span>
          Integrate your{' '}
          <a
            href="https://academy.geckoengage.com/en/articles/6962551-channels#h_5c534eb317"
            target="_blank"
          >
            Facebook page
          </a>{' '}
          with Gecko to respond to enquiries from a central inbox.
        </span>
      ),
      icon: facebookImg,
      onSave: this.onSave.bind(this),
    },
    {
      type: 'instagram',
      name: 'Instagram Direct Message',
      description: (
        <span>
          Integrate your{' '}
          <a
            href="https://academy.geckoengage.com/en/articles/6962551-channels#h_ae67d5910f"
            target="_blank"
          >
            Instagram Professional account
          </a>{' '}
          with Gecko to respond to enquiries from a central inbox.
        </span>
      ),
      icon: instagramImg,
      onSave: this.onSave.bind(this),
    },
    {
      type: 'twilio',
      name: 'SMS',
      description: (
        <span>
          Respond to enquiries through{' '}
          <a
            href="https://academy.geckoengage.com/en/articles/6962551-channels#h_6163b1813a"
            target="_blank"
          >
            SMS
          </a>{' '}
          directly from Gecko.
        </span>
      ),
      icon: twilioImg,
      onSave: (channel) => {
        return GeckoRequest.post('/channels/twilio', {
          name: channel.name,
          areaCode: channel.configuration.area_code,
          countryCode: channel.configuration.country_code,
          type: channel.configuration.type,
          chosenNumber: channel.configuration.twilio_number.phoneNumber,
          forwardTo: channel.configuration.forwarding_number,
        })
          .then((channel) => {
            GeckoLocation.goTo('/settings/channels');
            this.setState({ channel: null }, () => {
              return new GeckoModalService().close('Close channel add modal');
            });
            new GeckoToastService().success(
              'Your new channel has been created'
            );
          })
          .catch(renderError);
      },
    },
    // Removed for now as we dont support it!!
    // {
    //   type: 'twitter',
    //   name: 'Twitter',
    //   description: (
    //     <span>
    //       See and respond to direct messages from{' '}
    //       <a
    //         href="https://academy.geckoengage.com/en/articles/6962551-channels#h_bd60393b1d"
    //         target="_blank"
    //       >
    //         Twitter
    //       </a>{' '}
    //       to your Gecko inbox.
    //     </span>
    //   ),
    //   icon: twitterImg,
    //   onSave: this.onSave.bind(this),
    // },
    {
      type: 'mailgun',
      name: 'Email',
      description: (
        <span>
          Respond to{' '}
          <a
            href="https://academy.geckoengage.com/en/articles/6962551-channels#h_26029062e6"
            target="_blank"
          >
            email enquiries
          </a>{' '}
          from the centralised Gecko inbox.
        </span>
      ),
      icon: mailgunImg,
      onSave: this.onSave.bind(this),
    },
    // {
    //     type: 'wechat',
    //     name: 'WeChat',
    //     description: 'Respond to enquiries from WeChat through the centralised Gecko inbox.',
    //     icon: wechatImg,
    //     onSave: this.onSave.bind(this)
    // },
    {
      type: 'whatsapp',
      name: 'WhatsApp',
      description: (
        <span>
          Respond to{' '}
          <a
            href="https://academy.geckoengage.com/en/articles/6962551-channels#h_4870dc166e"
            target="_blank"
          >
            WhatsApp messages
          </a>{' '}
          through the centralised Gecko Inbox
        </span>
      ),
      icon: whatsappImg,
      onSave: this.onSave.bind(this),
    },
  ];

  createNewChannel(type, onSave) {
    return () => {
      const template = { name: '', configuration: {}, type: type };
      this.setState({ channel: template }, () => this.openModal(onSave));
    };
  }

  handleChange = (newValue) => {
    this.setState({ channel: newValue });
  };

  handleLiveChannelChange = (newValue) => {
    this.setState({ channel: newValue }, this.openNewLiveChannelModal);
  };

  handleEmailChannelChange = (newValue) => {
    this.setState({ channel: newValue }, this.openNewEmailChannelModal);
  };

  onSave(channel) {
    const name = channel.name;
    const hasSuggestionsWithNoConfig = () =>
      channel.configuration.ai_suggestions &&
      !(channel.configuration.ai_site_id && channel.configuration.ai_model);

    if (!name || name === '' || name === ' ') {
      return new GeckoToastService().error('Name is a required field.');
    }

    switch (channel.type) {
      case 'facebook':
        if (
          !channel.configuration.page_id ||
          !channel.configuration.auth_token
        ) {
          return new GeckoToastService().error(
            'You must select a page to subscribe to.'
          );
        }
        break;
      case 'instagram':
        if (
          !channel.configuration.page_id ||
          !channel.configuration.instagram_id ||
          !channel.configuration.auth_token
        ) {
          return new GeckoToastService().error(
            'You must select an account to subscribe to.'
          );
        }
        break;

      case 'live_chat':
        if (!channel.configuration.color) {
          return new GeckoToastService().error(
            'Please select a colour for your Live Chat.'
          );
        }
        if (hasSuggestionsWithNoConfig()) {
          return new GeckoToastService().error(
            'Please enter a valid Site ID and Model for your Live Chat.'
          );
        }
        break;
      case 'mailgun':
        if (!channel.configuration.pretty_email) {
          return new GeckoToastService().error(
            'Please specify a mask email address.'
          );
        }
        break;
      case 'wechat':
        if (
          !channel.configuration.token ||
          channel.configuration.token.length < 2 ||
          channel.configuration.token.length > 32
        ) {
          return new GeckoToastService().error(
            'WeChat token must have between 2 and 32 characters.'
          );
        }
        if (
          !channel.configuration.encodingAESKey ||
          channel.configuration.encodingAESKey.length !== 43
        ) {
          return new GeckoToastService().error(
            'Please specify a wechat EncodingAESKey with 43 characters.'
          );
        }
        break;
      case 'whatsapp':
        if (!channel.configuration.phone_number) {
          return new GeckoToastService().error('Please enter a phone number.');
        }
        break;
      default:
        return;
    }
    const newChannel = this.updateChannelWithPreChatForm(
      channel,
      channel.configuration.pre_chat_form,
      this.props.fields,
      this.props.accountId
    );

    return GeckoRequest.post('/channel', newChannel)
      .then((channel) => {
        if (channel.type === 'live_chat' || newChannel.type === 'mailgun') {
          new GeckoModalService().close();
          this.setState({ channel: channel });
          new GeckoToastService().success('Your new channel has been created');
          newChannel.type === 'live_chat'
            ? this.openNewLiveChannelModal()
            : this.openNewEmailChannelModal();
        } else {
          GeckoLocation.goTo('/settings/channels');
          this.setState({ channel: null }, () => {
            return new GeckoModalService().close('Close channel add modal');
          });
          new GeckoToastService().success('Your new channel has been created');
        }
      })
      .catch(renderError);
  }

  saveLiveChatChannel = () => {
    const name = this.state.channel.name;

    const hasSuggestionsWithNoConfig = () =>
      this.state.channel.configuration.ai_suggestions &&
      !(
        this.state.channel.configuration.ai_site_id &&
        this.state.channel.configuration.ai_model
      );

    if (!name || name === '' || name === ' ') {
      return new GeckoToastService().error('Name is a required field.');
    }
    if (!this.state.channel.configuration.color) {
      return new GeckoToastService().error(
        'Please select a colour for your Live Chat.'
      );
    }
    if (hasSuggestionsWithNoConfig()) {
      return new GeckoToastService().error(
        'Please enter a valid Site ID and Model for your Live Chat.'
      );
    }

    const channel = this.updateChannelWithPreChatForm(
      this.state.channel,
      this.state.channel.configuration.pre_chat_form,
      this.props.fields,
      this.props.accountId
    );

    GeckoRequest.post(/channel/ + this.state.channel.id, channel)
      .then((res) => {
        new GeckoModalService().close('Close channel edit modal');
        this.setState({ channel: null });
        GeckoLocation.goTo('/settings/channels');
        new GeckoToastService().success('Your changes have been saved.');
      })
      .catch(renderError);
  };

  updateChannelWithPreChatForm(channel, preChatForm = [], fields, accountId) {
    if (!Array.isArray(preChatForm)) {
      return channel;
    }

    const preChatFields = preChatForm.map((preChatField) => {
      const field = fields.find((field) => field.key === preChatField.key);
      return field ? { ...field, required: preChatField.required } : field;
    });
    const config = { ...channel.configuration, pre_chat_form: preChatFields };
    return {
      ...this.state.channel,
      account_id: accountId,
      configuration: config,
    };
  }

  saveEmailChannel = () => {
    const name = this.state.channel.name;
    if (!name || name === '' || name === ' ') {
      return new GeckoToastService().error('Name is a required field.');
    }
    if (!this.state.channel.configuration.pretty_email) {
      return new GeckoToastService().error(
        'Please specify a mask email address.'
      );
    }

    return GeckoRequest.post(
      /channel/ + this.state.channel.id,
      this.state.channel
    )
      .then((res) => {
        new GeckoModalService().close('Close channel edit modal');
        this.setState({ channel: null });
        GeckoLocation.goTo('/settings/channels');
      })
      .catch(console.error);
  };

  openNewLiveChannelModal() {
    new GeckoModalService().open(() => {
      return (
        <ChannelEditModal
          channel={this.state.channel}
          onChange={this.handleLiveChannelChange.bind(this)}
          onSave={this.saveLiveChatChannel.bind(this)}
          customFields={this.props.fields}
        />
      );
    });
  }

  openNewEmailChannelModal() {
    new GeckoModalService().open(() => {
      return (
        <ChannelEditModal
          channel={this.state.channel}
          onChange={this.handleEmailChannelChange.bind(this)}
          onSave={this.saveEmailChannel.bind(this)}
          customFields={this.props.fields}
        />
      );
    });
  }

  openModal(onSave) {
    new GeckoModalService().open(() => {
      return (
        <ChannelEditModal
          channel={this.state.channel}
          onChange={this.handleChange.bind(this)}
          onSave={() => onSave(this.state.channel)}
          customFields={this.props.fields}
        />
      );
    });
  }

  render() {
    const cardImages = this.channelTypes.map((channel) => {
      const button = {
        name: 'Add New Channel',
        handler: this.createNewChannel(channel.type, channel.onSave).bind(this),
      };
      if (['wechat', 'whatsapp'].indexOf(channel.type) !== -1) {
        return (
          <GeckoCol key={channel.type} width="12 md-4 lg-3">
            <GeckoCardImage img={channel.icon} padded>
              <h2>{channel.name}</h2>
              <p>{channel.description}</p>
              <GeckoBtn {...button} />
            </GeckoCardImage>
          </GeckoCol>
        );
      }
      return (
        <GeckoCol key={channel.type} width="12 md-4 lg-3">
          <GeckoCardImage img={channel.icon} padded>
            <h2>{channel.name}</h2>
            <p>{channel.description}</p>
            <GeckoBtn {...button} />
          </GeckoCardImage>
        </GeckoCol>
      );
    });
    return (
      <div className="content-margin NewChannel">
        <GeckoRow>{cardImages}</GeckoRow>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    accountId: state.appState.loggedInUser.account_id,
    defaultHeaders: state.appState.defaultHeaders,
    fields: state.fields,
  };
};

export default connect(mapStateToProps)(NewChannel);
